import { z } from 'zod';
import type { StateCreator } from 'zustand';

const eddQuestionSchema = z.object({
  questionId: z.string().min(1),
  question: z.string(),
  answer: z.union([z.string(), z.array(z.string())]),
});

const customerEddSchema = z
  .string()
  .transform((val) => JSON.parse(val))
  .pipe(z.array(z.unknown()).catch([]))
  .transform((items) =>
    items.filter((item): item is EddQuestion => eddQuestionSchema.safeParse(item).success)
  );

export const parseCustomerEdd = (json: string): EddQuestion[] => customerEddSchema.parse(json);

export interface EddQuestion {
  questionId: string;
  question: string;
  answer: string | string[];
}

export interface EddEmbeddedData {
  version: number;
  questions: EddQuestion[];
}

interface EddEmbeddedSlice {
  eddEmbeddedData: EddEmbeddedData;
  getEddEmbeddedQuestions: () => EddQuestion[];
  updateEddEmbeddedQuestions: (questions: EddQuestion[]) => void;
}

export const createEddEmbeddedSlice: StateCreator<EddEmbeddedSlice> = (set, get) => ({
  eddEmbeddedData: {
    version: 1,
    questions: [],
  },
  getEddEmbeddedQuestions: () => {
    return get().eddEmbeddedData.questions;
  },
  updateEddEmbeddedQuestions: (questions: EddQuestion[]) => {
    set({
      eddEmbeddedData: {
        ...get().eddEmbeddedData,
        questions,
      },
    });
  },
});

export type IEddEmbeddedSlice = EddEmbeddedSlice;
